/** Chunked read + native sha256 — shared by the hash worker and the main-thread fallback. */

export const HASH_CHUNK_BYTES = 8 * 1024 * 1024

export function toHex(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer)
  let out = ''
  for (let i = 0; i < bytes.length; i++) out += bytes[i]!.toString(16).padStart(2, '0')
  return out
}

/** Shared by the worker and the main-thread fallback. */
export async function digestInChunks(blob: Blob, onProgress: (ratio: number) => void, isAborted: () => boolean = () => false): Promise<string> {
  const size = blob.size
  const buffer = new Uint8Array(size)
  for (let offset = 0; offset < size; offset += HASH_CHUNK_BYTES) {
    if (isAborted()) throw new DOMException('Aborted', 'AbortError')
    const chunk = new Uint8Array(await blob.slice(offset, Math.min(size, offset + HASH_CHUNK_BYTES)).arrayBuffer())
    buffer.set(chunk, offset)
    onProgress(Math.min(1, (offset + chunk.length) / size) * 0.95)
  }
  const digest = await crypto.subtle.digest('SHA-256', buffer)
  onProgress(1)
  return toHex(digest)
}
